module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main-layout', [_c('div', {
    staticClass: "echarts"
  }, [_c('chart', {
    ref: "bar",
    attrs: {
      "options": _vm.bar3,
      "theme": "ovilia-green",
      "auto-resize": ""
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.3.0@vue-loader/lib/template-compiler.js?id=data-v-1f28c930!./~/.1.0.35@vux-loader/src/template-loader.js!./~/.10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/DetailQty.vue
// module id = 270
// module chunks = 2